import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import Container from '../../Atoms/Container/Container';
export const AccordionContext = createContext({});
const Accordion = ({ children, openedTabIndex, customCss }) => {
    const initialActiveState = (index) => {
        const initialArray = [];
        if (index)
            initialArray[index] = true;
        return initialArray;
    };
    const [activeIndexArr, setActiveIndexArr] = useState(initialActiveState(openedTabIndex));
    const accordionToggleHandler = (index) => {
        const newActiveIndex = [...activeIndexArr];
        newActiveIndex[index] = !newActiveIndex[index];
        setActiveIndexArr(newActiveIndex);
    };
    const childrenArr = children;
    return (_jsx(Container, Object.assign({ customCss: customCss, noPadding: true }, { children: childrenArr &&
            childrenArr.map((child, index) => (_jsx(AccordionContext.Provider, Object.assign({ value: { index, activeIndexArr, accordionToggleHandler } }, { children: child }), `section-${index}`))) }), void 0));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map